// import "../styles.css";
import React from "react";
import { useLocation, useRoutes } from "react-router-dom";
import { IndexPage } from "../pages";
import { SearchAndFilter } from "../pages/SearchAndFilter";
import MapListView from "../pages/MapListView";
import Following from "../pages/Following";
import UsefulInfo from "../pages/UsefulInfo";
import Destination from "../pages/Destination";
import Destinations from "../pages/Destinations";
import Listing from "../pages/Listing";
import ItineraryList from "../pages/ItineraryList";
import Itinerary from "../pages/Itinerary";
import BookingList from "../pages/BookingList";
import Booking from "../pages/Booking";
import SharedTrip from "../pages/SharedTrip";

export default function AppRoutes(ipInfo) {
  // const { token } = useAuth();
  const location = useLocation();
  // console.log(location)
  const routes = useRoutes([
    {
      path: "/",
      element: (<IndexPage ipInfo={ipInfo} />),
      loader: (params) => {
        console.log('home: ', params);
      },
    },
    {
      // Declared above "/:slug" for readability only — it is two segments, and
      // react-router ranks static segments above dynamic ones regardless.
      path: "/listing/:id",
      element: <Listing />,
    },
    {
      // A shared trip, opened from an invitation link. Deliberately NOT
      // behind a sign-in gate: the token in the path is the credential, and
      // requiring an account is the one thing guaranteed to stop an invited
      // person looking at the trip they were invited to.
      //
      // Two segments, so it outranks the "/:slug" catch-all below.
      path: "/trip/:token",
      element: <SharedTrip />,
    },
    {
      path: "/:slug",
      element: <Destinations ipInfo={ipInfo} />,
      loader: ({ params }) => {
        console.log('slug: ', params.slug); // "hotspur"
      }
    },
    {
      path: "/destination/:slug",
      element: <Destination ipInfo={ipInfo} />,
      loader: ({ params }) => {
        console.log('slug: ', params.slug); // "hotspur"
      }
    },
    {
      path: "/itinerary/:id",
      element: <Itinerary ipInfo={ipInfo} />,
      loader: ({ params }) => {
        console.log('itinerary id: ', params.id); // "hotspur"
      }
    },
    {
      path: "/itinerary-list",
      element: <ItineraryList ipInfo={ipInfo} />,
      loader: ({ params }) => {
        console.log('slug: ', params.slug); // "hotspur"
      }
    },
    {
      path: "/booking-list",
      element: <BookingList ipInfo={ipInfo} />,
      loader: ({ params }) => {
        console.log('booking list: ', params);
      }
    },
    {
      path: "/booking/:id",
      element: <Booking ipInfo={ipInfo} />,
      loader: ({ params }) => {
        console.log('booking id: ', params.id);
      }
    },
    {
      path: "/main",
      element: <SearchAndFilter />,
    },
    {
      // Universal search results, on the map. Criteria come from the query
      // string (`?q=`, `?location=`), which is why this is a static path and
      // not `/search/:term` — a location filter with no text, and text with no
      // location, are both valid searches.
      path: "/search",
      element: <MapListView />,
    },
    {
      // Not wrapped in ProtectedRoute: the page tells an anonymous traveller
      // what following is and offers a way in. Bouncing them to the home page
      // instead would explain nothing.
      path: "/following",
      element: <Following />,
    },
    {
      // Reached from the menu tile. Static in the sense that it writes nothing,
      // but everything on it is read from the taxonomy and the destination
      // list — so it cannot drift from what the app actually offers.
      path: "/useful-info",
      element: <UsefulInfo />,
    },
    // {
    //   path: "/profile",
    //   element: (
    //     <ProtectedRoute>
    //       <Gallery
    //         photos={[]}
    //         title="Amsterdam Zuid nightwalk"
    //         titleWidth={8.2}
    //         category="zuid"
    //         alt="A building in Amsterdam Zuid at night"
    //       />
    //     </ProtectedRoute>
    //   )
    // },
    // {
    //   path: "/london",
    //   element: (
    //     <Gallery
    //       photos={[]}
    //       title="White lines of Canary Wharf"
    //       titleWidth={8}
    //       category="canary"
    //       alt="A building in Canary Wharf"
    //     />
    //   )
    // }
  ]);

  return React.cloneElement(routes, { key: location.pathname })

  // return (
  //   <AppContext.Consumer>
  //   {serviceListing => (
  //       React.cloneElement(routes, { serviceProviders: serviceListing, key: location.pathname })
  //   )}
  // </AppContext.Consumer>
  // )

}
